import { render, staticRenderFns } from "./RBtn.vue?vue&type=template&id=2932748a&scoped=true&"
import script from "./RBtn.vue?vue&type=script&lang=js&"
export * from "./RBtn.vue?vue&type=script&lang=js&"
import style0 from "./RBtn.vue?vue&type=style&index=0&id=2932748a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932748a",
  null
  
)

/* custom blocks */
import block0 from "./RBtn.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports